<template>
  <div class='reg-filter'>
    <div id='activityFilter'>
      <div
        data-toggle="dropdown"
        class="text-right cursor-pointer"
      >
        <span class="dropdown-toggle cursor">
          <span @click="showHideFilter()">
            <img src="/static/images/icons/searchbar_filtermodal_icon.svg"/>
            <span class="filter-header">{{$t('filter')}}</span>
          </span>
        </span>
      </div>
      <div class="dropdown-menu dropdown-menu-left registration-header-filter-ul" :class="{'hide-field': collapsed}">
        <div class="col-xs-12 p-0 filter-card-header">
          <div class="col-xs-12 pb-1 pl-0 pr-0 filter-card-outline">
            <span class="col-xs-12 filter-text pl-0">{{$t('appliedFilters')}}</span>
            <div class="col-xs-12 plr-16">
                <p class="service-providers-filter-text pt-18">{{$t('products')}}</p>
                <multiselect
                openDirection="below"
                :placeholder="$t('selectItem')"
                :showLabels="false"
                :allow-empty="false"
                class="product-class-ellipsis multiselect-single-dropdown"
                :searchable="true"
                :options="products"
                label="name"
                value="id"
                v-model="selectedProduct"
                @input="filterSelected('product')"
                />
            </div>
            <div class="col-xs-12 p-0">
              <hr class="divider-line" />
            </div>
            <div class="col-xs-12 plr-16">
                <p class="service-providers-filter-text mb-7">{{$t('activityArea')}}</p>
                <multiselect
                openDirection="below"
                :showLabels="false"
                :close-on-select="true"
                :allow-empty="false"
                class="product-class-ellipsis multiselect-single-dropdown"
                :searchable="true"
                :options="activity_area"
                label="name"
                value="id"
                :placeholder="$t('selectItem')"
                v-model="selectedActivityArea"
                @input="filterSelected('activity_area')"
                />
            </div>
             <div class="col-xs-12 p-0">
              <hr class="divider-line" />
            </div>
            <div class="col-xs-12 plr-16">
                <p class="service-providers-filter-text mb-7">{{$t('testAndNorms')}}</p>
                <multiselect
                openDirection="below"
                :showLabels="false"
                :close-on-select="true"
                :allow-empty="false"
                class="product-class-ellipsis multiselect-single-dropdown"
                :searchable="true"
                :options="test_and_norms"
                :placeholder="$t('selectItem')"
                label="name"
                value="id"
                v-model="selectedTestAndNorms"
                @input="filterSelected('test_and_norm')"
                />
            </div>
          </div>
        </div>
        <div class="col-xs-12 footer">
          <button class="footer-btn footer-clear-btn" @click="clearAll" :disabled="checkDisabled()">{{$t('clearLabel')}}</button>
          <button class="footer-btn footer-apply-btn" @click="getFilteredData" :disabled="checkDisabled()">{{$t('apply')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import { getServiceProviderFiltersData, getDataBasedOnSelectedFilter, getServiceProviderFilteredData } from '../../apis/representationResources';
import EventBus from '../../utils/event-bus';

export default {
  data() {
    return {
      collapsed: true,
      activity_area: [],
      products: [],
      test_and_norms: [],
      selectedActivityArea: [],
      selectedProduct: [],
      selectedTestAndNorms: [],
      payload: {
        activity_area_id: 0,
        filter_level_1: '',
        filter_level_2: '',
        product_id: 0,
        test_and_norm_id: 0,
      },
    };
  },
  async created() {
    this.populateFilters();
  },
  methods: {
    async populateFilters() {
      const filterresult = await getServiceProviderFiltersData();
      this.activity_area = filterresult.activity_area;
      this.products = filterresult.product;
      this.test_and_norms = filterresult.test_and_norms;
    },
    showHideFilter() {
      this.collapsed = !this.collapsed;
    },
    async clearAll() {
      this.selectedTestAndNorms = [];
      this.selectedActivityArea = [];
      this.selectedProduct = [];
      this.populateFilters();
      EventBus.$emit('clear-applied-filter');
      this.showHideFilter();
      this.payload = {
        activity_area_id: 0,
        filter_level_1: '',
        filter_level_2: '',
        product_id: 0,
        test_and_norm_id: 0,
      };
      $(window).scrollTop(0);
    },
    async filterSelected(value) {
      if (value === 'product') {
        if (this.payload.filter_level_1 !== 'activity_area' && this.payload.filter_level_1 !== 'test_and_norm') {
          this.payload.filter_level_1 = 'product';
          this.payload.product_id = this.selectedProduct.id;
          this.payload.filter_level_2 = '';
          this.payload.activity_area_id = 0;
          this.payload.test_and_norm_id = 0;
          this.selectedTestAndNorms = [];
          this.selectedActivityArea = [];

          const response = await getDataBasedOnSelectedFilter(this.payload);
          this.activity_area = response.activity_area;
          this.test_and_norms = response.test_and_norm;
        } else if (this.payload.filter_level_1 === 'activity_area' && this.payload.filter_level_2 === '') {
          this.payload.filter_level_2 = 'product';
          this.payload.product_id = this.selectedProduct.id;

          const response = await getDataBasedOnSelectedFilter(this.payload);
          this.test_and_norms = response.test_and_norm;
        } else if (this.payload.filter_level_1 === 'test_and_norm' && this.payload.filter_level_2 === '') {
          this.payload.filter_level_2 = 'product';
          this.payload.product_id = this.selectedProduct.id;

          const response = await getDataBasedOnSelectedFilter(this.payload);
          this.activity_area = response.activity_area;
        } else {
          this.payload.product_id = this.selectedProduct.id;
          const response = await getDataBasedOnSelectedFilter(this.payload);
          console.log('response: ', response);
        }
      }

      if (value === 'activity_area') {
        if (this.payload.filter_level_1 !== 'product' && this.payload.filter_level_1 !== 'test_and_norm') {
          this.payload.filter_level_1 = 'activity_area';
          this.payload.activity_area_id = this.selectedActivityArea.id;
          this.payload.filter_level_2 = '';
          this.payload.product_id = 0;
          this.payload.test_and_norm_id = 0;
          this.selectedTestAndNorms = [];
          this.selectedProduct = [];

          const response = await getDataBasedOnSelectedFilter(this.payload);
          this.products = response.product;
          this.test_and_norms = response.test_and_norm;
        } else if (this.payload.filter_level_1 === 'product' && this.payload.filter_level_2 === '') {
          this.payload.filter_level_2 = 'activity_area';
          this.payload.activity_area_id = this.selectedActivityArea.id;

          const response = await getDataBasedOnSelectedFilter(this.payload);
          this.test_and_norms = response.test_and_norm;
        } else if (this.payload.filter_level_1 === 'test_and_norm' && this.payload.filter_level_2 === '') {
          this.payload.filter_level_2 = 'activity_area';
          this.payload.activity_area_id = this.selectedActivityArea.id;

          const response = await getDataBasedOnSelectedFilter(this.payload);
          this.products = response.product;
        } else {
          this.payload.activity_area_id = this.selectedActivityArea.id;
          const response = await getDataBasedOnSelectedFilter(this.payload);
          console.log('response: ', response);
        }
      }

      if (value === 'test_and_norm') {
        if (this.payload.filter_level_1 !== 'product' && this.payload.filter_level_1 !== 'activity_area') {
          this.payload.filter_level_1 = 'test_and_norm';
          this.payload.test_and_norm_id = this.selectedTestAndNorms.id;
          this.payload.filter_level_2 = '';
          this.payload.activity_area_id = 0;
          this.payload.product_id = 0;
          this.selectedProduct = [];
          this.selectedActivityArea = [];

          const response = await getDataBasedOnSelectedFilter(this.payload);
          this.products = response.product;
          this.activity_area = response.activity_area;
        } else if (this.payload.filter_level_1 === 'product' && this.payload.filter_level_2 === '') {
          this.payload.filter_level_2 = 'test_and_norm';
          this.payload.test_and_norm_id = this.selectedTestAndNorms.id;

          const response = await getDataBasedOnSelectedFilter(this.payload);
          this.activity_area = response.activity_area;
        } else if (this.payload.filter_level_1 === 'activity_area' && this.payload.filter_level_2 === '') {
          this.payload.filter_level_2 = 'test_and_norm';
          this.payload.test_and_norm_id = this.selectedTestAndNorms.id;

          const response = await getDataBasedOnSelectedFilter(this.payload);
          this.products = response.product;
        } else {
          this.payload.test_and_norm_id = this.selectedTestAndNorms.id;
          const response = await getDataBasedOnSelectedFilter(this.payload);
          console.log('response: ', response);
        }
      }
    },
    checkDisabled() {
      if (this.selectedActivityArea.id || this.selectedProduct.id || this.selectedTestAndNorms.id) {
        return false;
      }
      return true;
    },
    async getFilteredData() {
      const response = await getServiceProviderFilteredData(this.selectedProduct.id ? this.selectedProduct.id : '', this.selectedActivityArea.id ? this.selectedActivityArea.id : '', this.selectedTestAndNorms.id ? this.selectedTestAndNorms.id : '');
      EventBus.$emit('appliedFilteredData', response);
      this.showHideFilter();
      $(window).scrollTop(0);
    },
  },
};
</script>

<style scoped>
.footer {
  position: absolute;
  bottom: 12px;
  padding: 0px 12px 0px 12px;
  display: flex;
  justify-content: space-between;
}

.filter-header {
  color: #4D4D4D;
  font-size: 14px;
  padding: 3px 16px 0px 9px;
  position: relative;
  top: 2px;
}

.footer-btn {
border-radius: 3px;
font-weight: 600;
font-size: 16px;
line-height: 22px;
border: 1px solid transparent;
padding: 6px 16px;
cursor: pointer;
}

.footer-btn:disabled {
  cursor: not-allowed;
}

.footer-clear-btn, .footer-clear-btn:hover {
background: #E6E6E6;
color: #404040;
}

.footer-apply-btn, .footer-apply-btn:hover {
background: #01518A;
color: #ffffff;
}

.divider-line {
  border-top: 1px solid #D3D3D3;
  padding: 0px;
  margin: 32px 0px 30px 0px;
}

.plr-16 {
  padding-left: 16px;
  padding-right: 16px;
}

.mb-7 {
  margin-bottom: 7px;
}

.service-providers-filter-text {
  font-size: 16px;
  line-height: 22px;
  color: #4D4D4D;
}

.multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select{
  padding-top: 0px !important;
}
.product-class-ellipsis.multiselect-single-dropdown
>>> .multiselect__single,
.accredited-by-ellipsis.multiselect-single-dropdown
>>> .multiselect__single{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 450px;
  margin-bottom: 0px;
}
.multiselect-single-dropdown.multiselect--active::before{
  content: none;
}
.multiselect--active
  >>> .multiselect__tags{
    border-radius: 3px !important;
    border-bottom: none;
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    border-top: 1px solid #CCCCCC;
    border-right: 1px solid #CCCCCC;
    border-left: 1px solid #CCCCCC;
  }
  .multiselect--active >>> .multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected.multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected:after{
    content: none !important;
  }
.multiselect{
  min-height: 34px;
}
  .multiselect-single-dropdown
  >>> .multiselect__tags{
    border-radius: 3px;
    height: 34px;
    /* padding: 9px 40px 11px 11px; */
    padding: 3px 40px 6px 11px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__select{
    padding-top: 7px !important;
  }
  .multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select{
    padding-top:8px !important;
  }
  .multiselect-single-dropdown.multiselect--disabled {
        background: #ededed;
        pointer-events: none;
        opacity: 0.4;

  }
  .multiselect-single-dropdown
  >>> .multiselect__select:before{
    position: relative;
    right: 0;
    color: #4D4D4D;
    margin-top: 4px;
    border-color:  #4D4D4D transparent transparent;
    border-style: solid;
    border-width: 7px 7px 0;
    content: "";
    transform: rotate(0) !important;
    padding: 0px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__option:hover{
    background: #FFFFFF !important;
  }
  .multiselect--active
  >>> .multiselect__select{
    padding-bottom: 6px !important;
    padding-top: 4px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper .multiselect__option--highlight.multiselect__option--selected{
    border: 1px solid #0A99FF;
  }
  .multiselect-single-dropdown.multiselect--active
  >>> .multiselect__option--selected{
    background: #FFFFFF !important;
    border: 1px solid #0A99FF;

  }
  .multiselect-single-dropdown.multiselect--active
  >>> .multiselect__option--selected span{
    /* font-weight: 600 !important; */
  }
  .multiselect-single-dropdown
    >>> .multiselect__option--selected:before {
    content: none;
  }
  .multiselect--active
  >>> .multiselect__tags::after{
    content: '';
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 11px;
    right: -13px;
    border: 0.5px solid #CCCCCC !important;
    opacity:0.5;
    width: 95%;

  }
  .multiselect-single-dropdown
  >>> .multiselect__single {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
    overflow: visible;
    padding-left:0px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__placeholder {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
    overflow: visible;
  }
  .multiselect-single-dropdown >>> .multiselect__input::placeholder{
     color: #4D4D4D !important;
     padding-left:4px !important;
  }
.multiselect--active
  >>>  .multiselect__single,
  .multiselect--active
  >>> .multiselect__placeholder{
    padding: 4px 40px 4px 12px;
  }
 .multiselect--active
  >>> .multiselect__input{
    padding-left: 1px !important;
    padding-top: 4px !important;
    padding-bottom: 4px;
    margin-bottom: 0px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .multiselect-single-dropdown >>> .multiselect__input{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
    padding-top: 1px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content{
    margin-top: 5px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element span{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element .multiselect__option{
    padding-left: 16px;
    padding-top:11px;
    padding-bottom: 10px;
    padding-right: 0px;
  }
  @media screen and (max-width: 1025px) {
    .multiselect--active
  >>> .multiselect__tags::before{
    left: 10px;
    width:94%
  }
}
.multiselect-single-dropdown.multiselect--active
>>> .multiselect__content-wrapper{
    border:1px solid #CCCCCC;
    border-top: none;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    margin-top: 0px;
    max-height: 229px !important;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper{
    -webkit-box-shadow:none;
     box-shadow: none;
  }

.pt-18{
  padding-top: 18px;
}

.filter-card-header {
  background: #FFFFFF;
  /* box-shadow: 4px 4px 10px rgb(0 0 0 / 10%); */
}

.reg-filter {
  position: absolute;
  z-index: 3;
  /* left: 15px !important;
  margin-left: -20px; */
  top: 14px;
  /* top: 2px; */
  right: 0px;
}

.registration-header-reg-filter {
  position: absolute;
  z-index: 3;
  left: 15px !important;
  top: -9px;
  margin-left: -30px;
}

.mt-7 {
  margin-top: 7px;
}

.smart-docs {
  top: unset;
  margin-top: 45px;
}
#activityFilter {
  height: 52px;
  margin-left: 5px;
}

.reg-dropdown {
  padding: 0px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px rgb(0 0 0 / 25%);
  border-radius: 0px 4px 4px 0px;
}

.registration-header-reg-dropdown {
  padding: 0px 28px 5px 0px;
}

.registration-header-filter-ul {
  position: relative;
  padding: 0px;
  width: 320px;
  min-height: 785px;
  display: block;
  background: #ffffff;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.1);
  margin-top: 20px !important;
  border-radius: 0px;
  border: 1px solid #B3B3B3;
}

::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-thumb {
  background: #D9D9D9;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
}
::-webkit-scrollbar-thumb:hover {
  background: #D9D9D9;;
}
.dropdown-menu-left {
  right: auto;
  left: 0px;
  top: -4px;
  margin: 6px 0 0;
}

.filter-text{
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #000000;
  padding-left: 14px;
}
.filter-card-outline {
  padding: 22px 0px 24px 0px;
}

.hide-field {
  display: none !important;
}
</style>
